module.exports = __webpack_public_path__ + "static/media/bgLeparc.bf2fc122.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/bgLeparc.png
// module id = 1259
// module chunks = 0